module.exports = __webpack_public_path__ + "img/community.7c1be3d5.png";